import React from "react";
import { Card } from "@/components/layout/PageShell";
import { cn } from "@/lib/utils";

/**
 * Compact KPI strip for Report Center — keeps summary visible without competing with tables.
 * @param {{ items: Array<{ label: string, value: React.ReactNode, emphasize?: boolean }>, className?: string }} props
 */
export function ReportKpiStrip({ items = [], className }) {
  if (!items.length) return null;

  const cols =
    items.length <= 2
      ? "grid-cols-2"
      : items.length <= 4
        ? "grid-cols-2 sm:grid-cols-4"
        : items.length <= 6
          ? "grid-cols-2 sm:grid-cols-3 lg:grid-cols-6"
          : "grid-cols-2 sm:grid-cols-4 lg:grid-cols-6";

  return (
    <div className={cn("grid gap-2 mb-3", cols, className)} data-testid="report-kpi-strip">
      {items.map((c) => (
        <Card
          key={c.label}
          className={cn(
            "px-2.5 py-2 border-[#F0E0D4] bg-[#FFFCF9]",
            c.emphasize && "border-brand-orange/35 bg-[#FFF3E8]",
          )}
        >
          <p className="text-[10px] font-semibold uppercase tracking-wide text-brand-brown/45 mb-0.5 truncate">
            {c.label}
          </p>
          <p
            className={cn(
              "text-[13px] font-bold text-brand-brown tabular-nums leading-tight truncate",
              c.emphasize && "text-brand-orange",
            )}
          >
            {c.value}
          </p>
        </Card>
      ))}
    </div>
  );
}
